import React, { createContext } from 'react'
const EditorContext = createContext({
  loading: false,
})
export default EditorContext
